(() => {
  const button = document.querySelector('.amaca-cookie-preferences');
  if (!button) return;
  button.addEventListener('click', async () => {
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    try {
      if (!window.privacyBanner?.showPreferences) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = '/cdn/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.append(script);
        });
      }
      await window.privacyBanner.showPreferences();
    } catch (error) {
      console.error('Cookie preferences could not be opened', error);
      button.removeAttribute('aria-busy');
      window.location.assign('/policies/privacy-policy');
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
